// Dependency imports
import { memo, useCallback } from 'react';
import { IconButton } from '@material-ui/core';
import moment from 'moment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineTwoToneIcon from '@mui/icons-material/ErrorOutlineTwoTone';

// Local imports
import CircularProgressWithLabel from 'components/progress/circularProgress';

interface NotificationDataTypes {
  color: string;
  activity: string;
  missing: boolean | number;
  activity_duration: number;
  sequence: boolean | string;
  current_second: boolean;
  start_time: number;
  end_time: number;
}

interface NotificationItemProps {
  key: number;
  data: NotificationDataTypes;
  index: number;
  activityDataLength: number;
}

const NotificationItem = memo(
  ({ data, index, activityDataLength }: NotificationItemProps) => {
    const setNotificationColor = useCallback(
      (value: boolean | string | number) => {
        if (value === 1) return 'rgb(0,248,0)';
        if (value === 0) return 'red';
        return 'orange';
      },
      []
    );

    return (
      <div className="notify-container">
        <CircularProgressWithLabel
          style={{
            height: '30px',
            width: '30px',
            color: data?.color || setNotificationColor(data?.sequence)
          }}
          variant={
            index === activityDataLength - 1 ? 'indeterminate' : 'determinate'
          }
          value={
            <IconButton
              disableRipple
              style={{
                color: data?.color || setNotificationColor(data?.sequence),
                alignContent: 'center'
              }}
            >
              {data?.missing === 0 ? (
                <CheckCircleIcon />
              ) : (
                <ErrorOutlineTwoToneIcon />
              )}
            </IconButton>
          }
          size={60}
        />
        <div className="notify-main-data">
          <div className="notification-head">
            <div>{data?.activity}</div>
          </div>
          <div className="timer">
            {moment.utc(data?.activity_duration * 1000).format('HH:mm:ss')}
          </div>
        </div>
      </div>
    );
  }
);

export default NotificationItem;
